module.exports = __webpack_public_path__ + "e552329976f16e12a23bc0f558d0949d.png";